export default {"src":"/_next/static/media/descriptionMecenat2.c95748d2.svg","height":200,"width":336,"blurWidth":0,"blurHeight":0};